import React from "react"
import { Link } from "react-router-dom"
import Image from "../components/Image"

interface BlogData {
  id: string
  featuredImage: string
  title: string
  createDay: string
  createMonth: string
  createYear: string
  filesource: string
}

interface BlogProps {
  data: BlogData
}

const Blog: React.FC<BlogProps> = ({ data }) => {
  const {
    id,
    featuredImage,
    title,
    createDay,
    createMonth,
    createYear,
    filesource,
  } = data

  const getShortMonth = (month: string): string => {
    return month.slice(0, 3)
  }

  const getNospaceTitle = (filesource: string): string => {
    const tempArr = filesource.split("/")
    const fileName = tempArr[tempArr.length - 1]
    const getName = fileName.slice(0, -3)
    return getName
  }

  return (
    <div className="mi-blog">
      <div className="mi-blog-image">
        <Link to={`${id}/${getNospaceTitle(filesource)}`}>
          {/* <ProgressiveImage
            src={featuredImage}
            placeholder="/images/blog-image-placeholder.png"
          >
            {(src) => <img src={src} alt={title} />}
          </ProgressiveImage> */}
          <Image src={featuredImage} alt={title} height="340" width="600" />
        </Link>
        <div className="mi-blog-date">
          <span className="date">{createDay}</span>
          <span className="month">{getShortMonth(createMonth)}</span>
          <span className="year">{createYear}</span>
        </div>
      </div>
      <div className="mi-blog-content">
        <h5>
          <Link to={`${id}/${getNospaceTitle(filesource)}`}>{title}</Link>
        </h5>
      </div>
    </div>
  )
}

export default Blog
